import React, { useContext } from 'react';
import { getCurrentDateLokalised } from '@shared/utils/date';
import { Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';

const ActivityTodayHeader = () => {
    const { t } = useTranslation();

    const { dayKey, day, monthKey } = getCurrentDateLokalised();

    return (
        <View >
            <Text className="font-heading mb-2 text-3xl">
                {t('screens.activities.title')}
            </Text>
            <Text className="mb-6 text-black text-lg">
                {/* @ts-ignore */}
                {`${t(dayKey)}, ${day} ${t(monthKey)}`}
            </Text>
        </View>
    );
};

export default ActivityTodayHeader;
